import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    approve: string;
    decline: string;
    manage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label to approve an access request */
            approve: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestCTAs.approve?c=4o4tfoz5qv9k", defaultMessage: "Approve" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to decline an access request */
            decline: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestCTAs.decline?c=3hwtswn6joobh", defaultMessage: "Decline" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to navigate to plan management */
            manage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestCTAs.manage?c=22szennuspms5", defaultMessage: "Manage Plan" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
